/**
 * DirectionsCounter.tsx — "34 of 200 characters" under a Directions box.
 *
 * Owner repo: @thegpservice/gpsclinics-portal. Follow-up from the 2026-09-26
 * handoff: the prescribe form's Directions box had no limit, but the server
 * refuses more than {@link MAX_DIRECTIONS_LENGTH} characters, so a long
 * instruction only failed on the press, as a 400.
 *
 * It COUNTS, it never cuts: no `maxLength` (a silent truncation of a pasted
 * instruction to a patient is the dangerous way to fail). Over the limit the
 * line turns to the danger ink and says how far over, and the form's own gate
 * (`prescribeRequirements.lineRequirements`) refuses the line in words.
 *
 * NOT a live region: it changes on every keystroke. The box names it in its
 * `aria-describedby`, so a screen reader hears it on focus — the rule the
 * "Still needed" hint follows.
 */
import { MAX_DIRECTIONS_LENGTH } from './prescribeRequirements';

export function DirectionsCounter({ id, value }: { id: string; value: string }) {
  const length = value.trim().length;
  const over = length > MAX_DIRECTIONS_LENGTH;
  return (
    <p
      id={id}
      data-over={over ? 'true' : undefined}
      style={{
        margin: '4px 0 0',
        fontSize: '12.5px',
        fontVariantNumeric: 'tabular-nums',
        color: over ? 'var(--gps-danger-text)' : 'var(--gps-muted)',
        fontWeight: over ? 600 : 400,
      }}
    >
      {length} of {MAX_DIRECTIONS_LENGTH} characters{over ? ` — ${length - MAX_DIRECTIONS_LENGTH} too many` : ''}
    </p>
  );
}
